import React from "react";
import HOC from "../../components/HOC";
import InvoiceList from "../../components/screen/invoice/InvoiceList";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import BreadcrumbInvoice from "../../components/screen/invoice/BreadcrumbInvoice";

const InvoicePage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={`${isWarehouse ? "Central Warehouse" : ""} Invoice List`}
        mainComponent={
          <ThemeProvider theme={theme}>
            <InvoiceList isWarehouse={isWarehouse ? isWarehouse : false} />
          </ThemeProvider>
        }
        breadcrumb={
          <BreadcrumbInvoice isWarehouse={isWarehouse ? isWarehouse : false} />
        }
        pageRole={isWarehouse ? 42 : 11}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(InvoicePage);
